(function () {
  'use strict';

  function toggleBadge(badge, badgesWithDesc) {
    var isOpen = badge.classList.contains('science-flow__badge--open');
    badgesWithDesc.forEach(function (b) {
      b.classList.remove('science-flow__badge--open');
      var lbl = b.querySelector('.science-flow__badge-inner');
      if (lbl) lbl.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      badge.classList.add('science-flow__badge--open');
      var lbl = badge.querySelector('.science-flow__badge-inner');
      if (lbl) lbl.setAttribute('aria-expanded', 'true');
    }
  }

  var COLLAPSE_BREAKPOINT = 1000;

  function isCollapseMode() {
    return window.innerWidth <= COLLAPSE_BREAKPOINT;
  }

  function closeAllBadges(badgesWithDesc) {
    badgesWithDesc.forEach(function (b) {
      b.classList.remove('science-flow__badge--open');
      var lbl = b.querySelector('.science-flow__badge-inner');
      if (lbl) lbl.setAttribute('aria-expanded', 'false');
    });
  }

  function initSfBadges() {
    var sections = document.querySelectorAll('.science-flow');
    sections.forEach(function (section) {
      var badges = section.querySelectorAll('.science-flow__badge');
      if (!badges.length) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var badgesWithDesc = [];

      badges.forEach(function (badge) {
        if (!badge.querySelector('.science-flow__badge-desc')) return;
        badgesWithDesc.push(badge);

        var inner = badge.querySelector('.science-flow__badge-inner');
        inner.setAttribute('role', 'button');
        inner.setAttribute('tabindex', '0');
        inner.setAttribute('aria-expanded', 'false');

        /* Listener en el badge completo para capturar clicks en toda el área */
        badge.addEventListener('click', function (e) {
          if (!isCollapseMode()) return;
          /* Ignorar clicks que vienen desde dentro del desc */
          var desc = badge.querySelector('.science-flow__badge-desc');
          if (desc && desc.contains(e.target)) return;
          e.preventDefault();
          toggleBadge(badge, badgesWithDesc);
        });

        inner.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleBadge(badge, badgesWithDesc);
          }
        });

        inner.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleBadge(badge, badgesWithDesc);
          }
        });
      });

      /* Autoplay desktop: cicla los badges con desc cada 3s */
      var autoplayTimer = null;
      var autoplayCurrent = 0;
      var isHovered = false;
      var autoplayStarted = false;

      function autoplayStep() {
        if (isCollapseMode() || !badgesWithDesc.length) return;
        badgesWithDesc.forEach(function (b) {
          b.classList.remove('science-flow__badge--open');
          var lbl = b.querySelector('.science-flow__badge-inner');
          if (lbl) lbl.setAttribute('aria-expanded', 'false');
        });
        var current = badgesWithDesc[autoplayCurrent];
        current.classList.add('science-flow__badge--open');
        var lbl = current.querySelector('.science-flow__badge-inner');
        if (lbl) lbl.setAttribute('aria-expanded', 'true');
        autoplayCurrent = (autoplayCurrent + 1) % badgesWithDesc.length;
      }

      function startAutoplay() {
        if (isCollapseMode() || !badgesWithDesc.length) return;
        stopAutoplay();
        autoplayStep();
        autoplayTimer = setInterval(autoplayStep, 3000);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      /* Hover: cierra todos los --open (CSS :hover se encarga de mostrar el desc),
         detiene el timer y lo reanuda al salir */
      badgesWithDesc.forEach(function (badge) {
        badge.addEventListener('mouseenter', function () {
          stopAutoplay();
          closeAllBadges(badgesWithDesc);
        });
        badge.addEventListener('mouseleave', function () {
          if (!isCollapseMode() && autoplayStarted) startAutoplay();
        });
      });

      /* Al entrar en modo collapse, abrir el primero por defecto */
      function onModeChange(collapseMode) {
        if (collapseMode) {
          stopAutoplay();
          closeAllBadges(badgesWithDesc);
          if (badgesWithDesc.length) {
            badgesWithDesc[0].classList.add('science-flow__badge--open');
            var firstLabel = badgesWithDesc[0].querySelector('.science-flow__badge-inner');
            if (firstLabel) firstLabel.setAttribute('aria-expanded', 'true');
          }
        } else {
          /* Al volver a desktop, arrancar autoplay */
          closeAllBadges(badgesWithDesc);
          autoplayCurrent = 0;
          startAutoplay();
        }
      }

      if (isCollapseMode()) {
        onModeChange(true);
      }

      /* Escuchar resize para cambiar de modo dinámicamente */
      var wasCollapse = isCollapseMode();
      window.addEventListener('resize', function () {
        var nowCollapse = isCollapseMode();
        if (nowCollapse !== wasCollapse) {
          wasCollapse = nowCollapse;
          onModeChange(nowCollapse);
        }
      });

      if (reducedMotion) return;

      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      section.classList.add('science-flow--badges-ready');

      var badgeArray = Array.from(badges);
      var totalBadges = badgeArray.length;
      var cardWrap = section.querySelector('.science-flow__card-wrap') || section;

      var badgeTl = gsap.timeline({
        scrollTrigger: {
          trigger: cardWrap,
          start: 'top 50%',
          end: '+=350',
          scrub: 0.6,
          once: true,
          onLeave: function () {
            if (!isCollapseMode()) startAutoplay();
          }
        }
      });

      badgeArray.forEach(function (badge, i) {
        var position = i / totalBadges;
        badgeTl.fromTo(
          badge,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, ease: 'power2.out', duration: 1 / totalBadges },
          position
        );
      });
    });
  }

  function initSfFadeText() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var containers = document.querySelectorAll('[data-science-flow-fade-text]');
    if (!containers.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    containers.forEach(function (container) {
      /* Buscar la sección padre .science-flow para usarla como trigger */
      var section = container.closest('.science-flow') || container;

      container.querySelectorAll('.science-flow__fade-line').forEach(function (line) {
        var text = line.textContent;
        var html = '';
        for (var i = 0; i < text.length; i++) {
          var ch = text[i];
          if (ch === ' ') {
            html += '<span class="science-flow__char science-flow__char--space" aria-hidden="true">\u00a0</span>';
          } else {
            var safe = ch.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            html += '<span class="science-flow__char" aria-hidden="true">' + safe + '</span>';
          }
        }
        line.innerHTML = html;
      });

      var chars = Array.from(container.querySelectorAll('.science-flow__char'));

      if (reducedMotion) {
        gsap.set(chars, { opacity: 1 });
        return;
      }

      var totalChars = chars.length;
      if (!totalChars) return;

      /*
       * Animación scrub letra por letra anclada a la sección:
       * - start: cuando el TOP de la sección llega al 10% del viewport (= 90% visible)
       * - end:   400px de scroll después del start, para dar recorrido al scrub
       * Cada letra ocupa una franja proporcional del recorrido total.
       */
      var scrollDuration = 400; /* px de scroll para completar todas las letras */

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 20%',        /* sección más arriba en vista */
          end: '+=' + scrollDuration,
          scrub: 0.6,              /* scrub suave, sigue al scroll */
          once: false
        }
      });

      chars.forEach(function (char, i) {
        /* Cada char ocupa una franja proporcional; se solapan levemente */
        var position = i / totalChars;
        tl.fromTo(
          char,
          { opacity: 0.12 },
          { opacity: 1, ease: 'none', duration: 1 / totalChars },
          position
        );
      });
    });
  }

  function initSfCtaSmoothScroll() {
    var ctas = document.querySelectorAll('.science-flow__cta');
    if (!ctas.length) return;

    function getHeaderOffset() {
      var header = document.querySelector('#header-component, .header, header[role="banner"]');
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);
      if (style.position === 'fixed' || style.position === 'sticky') {
        return rect.height;
      }
      return 0;
    }

    function targetTop(target) {
      return target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 16;
    }

    function correctIfDrifted(target, attempts) {
      attempts = attempts || 0;
      if (attempts > 4) return;

      var desired = targetTop(target);
      var current = window.pageYOffset;

      if (Math.abs(desired - current) > 2) {
        window.scrollTo({ top: desired, behavior: 'smooth' });
        setTimeout(function () { correctIfDrifted(target, attempts + 1); }, 350);
      }
    }

    function waitForScrollEnd(cb) {
      var lastY = window.pageYOffset;
      var stable = 0;
      var ticks = 0;

      function tick() {
        ticks++;
        var y = window.pageYOffset;
        if (Math.abs(y - lastY) < 0.5) {
          stable++;
          if (stable >= 4) return cb();
        } else {
          stable = 0;
        }
        lastY = y;
        if (ticks > 180) return cb();
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    ctas.forEach(function (cta) {
      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;

      cta.addEventListener('click', function (e) {
        var id = href.slice(1);
        var target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();

        if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
          ScrollTrigger.refresh();
        }

        window.scrollTo({ top: targetTop(target), behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', href);
        }

        waitForScrollEnd(function () {
          if (typeof ScrollTrigger !== 'undefined' && ScrollTrigger.refresh) {
            ScrollTrigger.refresh();
          }
          correctIfDrifted(target);
        });
      });
    });
  }

  function init() {
    initSfBadges();
    initSfFadeText();
    initSfCtaSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
